import React from 'react';
import './KioskCard.scss';

const KioskCard = ({ className, value, label, icon, icon_dark, darkMode }) => (
  <div className="kiosk-card">
    <div className={`${className} stat-card`}>
      <img src={darkMode ? icon_dark : icon} alt={`${className} icon`} />
      <div className="stats">
        <p className="value">{value}</p>
        <p className="label">{label}</p>
      </div>
    </div>
  </div>
);

export default KioskCard;
